import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const EVALUATE_RECORDS_TYPE_OK = "EVALUATE_RECORDS_TYPE_OK";
export const EVALUATE_RECORDS_TYPE_ERR = "EVALUATE_RECORDS_TYPE_ERR";

export function evaluateRecordsTypeOk(payload) {
  return {
    type: EVALUATE_RECORDS_TYPE_OK,
    payload,
  };
}

export function evaluateRecordsTypeErr(payload) {
  return {
    type: EVALUATE_RECORDS_TYPE_ERR,
    payload,
  };
}

export const evaluateRecordsTypeService = {
  getDetail,
};

function getDetail(data) {
  var params = "id=" + data;
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.EvaluateRecordsType_GetDetail, params)
      .then((response) => {
        dispatch(evaluateRecordsTypeOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(evaluateRecordsTypeErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        ShowNotification(error.errorMessage, NotificationMessageType.Error);
      });
  };
}
